import qs from "qs";
import {
  isIE,
  getAssetsFile,
  getCityAssetsFile,
  copyText,
} from "@/assets/js/utils";
import defaultImage from "@/assets/img/business_empty.png";
import amountFiltering from "@/assets/js/amountFiltering";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "这周",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * (7 - start.getDay())
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * (start.getDate() - 1)
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上个月",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * (30 + start.getDate())
              );
              end.setTime(end.getTime() - 3600 * 1000 * 24 * end.getDate());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      defaultImage,
      message_minxin: {
        msg: "",
        type: "error",
      },
      btn_loading: false,
      query: this.$route.query,
      descriptionsContentStyle: {
        "min-width": "1px",
        "max-width": "1px",
        "word-break": "break-all",
      },
      descriptionsLabelStyle: { width: "150px", "word-break": "break-all" },
      pageApis: {
        GongcTenderbid: "bidGuarantee", //工程投标保函
        GongcSafeLiability: "safeLiability", // 安责险
        PurchaseTenderbid: "purchaseBidGuarantee", //政采投标保函
        CourtLowsuit: "courtLawsuit", //法院诉讼
        PurchaseContract: "purchaseContractFulfill", //政采合同履约
        PurchaseContractCancel: "purchaseContractFulfill", //政采合同履约
        GongcContractFulfillInsure: "engineeringContractFulfill", //工程合同履约
        GongcContractFulfillCancel: "engineeringContractFulfill",
        GongcConstructionTeamInsure: "engineeringConstructionTeam", // 建筑工程团意险
        GongcConstructionTeamCancel: "engineeringConstructionTeam", // 建筑工程团意险
        GongcConstructionAllRiskInsure: "engineeringAllRisk", //建筑工程一切险
        GongcConstructionAllRiskCancel: "engineeringAllRisk", //建筑工程一切险
        GongcPeasantInsure: "engineeringPeasant", ///农民工工资保函
        GongcPeasantCancel: "engineeringPeasant", //农民工工资保函
        GongcQuality: "engineeringQuality", //工程质量保函
        GongcQualityCancel: "engineeringQuality", //工程质量保函
        CustomsInsure: "customsOrder", //海关
        CustomsCancel: "customsOrder",
        GongcOwnerAdvancePaymentInsure: "engineeringOwnerAdvancePayment", //工程预付款
        GongcOwnerAdvancePaymentCancel: "engineeringOwnerAdvancePayment",
        PurchaseOwnerAdvancePaymentInsure: "purchaseOwnerAdvancePayment", //政采预付款
        PurchaseOwnerAdvancePaymentCancel: "purchaseOwnerAdvancePayment",
        OwnerEnsurePaymentInsure: "ownerEnsurePayment", //业主支付
        OwnerEnsurePaymentCancel: "ownerEnsurePayment",
        AuctionInsure: "auction", //竞买
        AuctionCancel: "auction", //竞买
        TravelInsure: "travel", //文旅保函
        TravelCancel: "travel", //文旅保函
        CarRiskInsure: "carRisk", //汽车险
        CarRiskCancel: "carRisk", //汽车险
      },
      signApis: {
        GongcTenderbid: "/customer/seal/", //工程投标保函
        GongcNongmgSocietyDeclare: "/customer/seal/", //工程投标保函
        GongcSafeLiability: "/customer/seal/", // 安责险
        PurchaseTenderbid: "/customer/seal/", //政采投标保函
        CourtLowsuit: "/customer/seal/", //法院诉讼
        PurchaseContractFulfillInsure: "/customer/seal/external/", //政采合同履约
        PurchaseContractFulfillCancel: "/customer/seal/external/", //政采合同履约
        GongcContractFulfillInsure: "/customer/seal/external/", //工程合同履约
        GongcContractFulfillCancel: "/customer/seal/external/", //工程合同履约
        GongcConstructionTeamInsure: "/customer/seal/external/", // 建筑工程团意险
        GongcConstructionTeamCancel: "/customer/seal/external/", // 建筑工程团意险
        GongcConstructionAllRiskInsure: "/customer/seal/external/", //建筑工程一切险
        GongcConstructionAllRiskCancel: "/customer/seal/external/", //建筑工程一切险
        GongcPeasantInsure: "/customer/seal/external/", ///农民工工资保函
        GongcPeasantCancel: "/customer/seal/external/", //农民工工资保函
        GongcQualityInsure: "/customer/seal/external/", //工程质量保函
        GongcQualityCancel: "/customer/seal/external/", //工程质量保函
        CustomsInsure: "/customer/seal/external/", //海关投保
        CustomsCancel: "/customer/seal/external/", //海关退保
        GongcOwnerAdvancePaymentInsure: "/customer/seal/external/", //工程预付款投保
        GongcOwnerAdvancePaymentCancel: "/customer/seal/external/", //工程预付款退保
        PurchaseOwnerAdvancePaymentInsure: "/customer/seal/external/", //政采预付款投保
        PurchaseOwnerAdvancePaymentCancel: "/customer/seal/external/", //政采预付款退保
        OwnerEnsurePaymentInsure: "/customer/seal/external/", //业主投保
        OwnerEnsurePaymentCancel: "/customer/seal/external/", //业主退保
        WinbidLoanApply: "/customer/seal/",
        AuctionInsure: "/customer/seal/external/", //竞买
        AuctionCancel: "/customer/seal/external/", //竞买
        TravelInsure: "/customer/seal/external/", //文旅保函
        TravelCancel: "/customer/seal/external/", //文旅保函
        CourtLawsuitDocument: "/customer/seal/external/", //法院诉讼文书生成
        CarRiskInsure: "/customer/seal/external/", //汽车险
        CarRiskCancel: "/customer/seal/external/", //汽车险
      },
      oldType: [
        "GongcTenderbidInsure", //工程投标保函
        "GongcSafeLiabilityInsure", // 安责险
        "PurchaseTenderbidInsure", //政采投标保函
        "CourtLowsuitInsure", //法院诉讼
        "WinbidLoanApply", //助贷
      ],
    };
  },
  directives: {
    amountFiltering,
  },
  methods: {
    getAssetsFile,
    getCityAssetsFile,
    setDefaultImage(e) {
      e.target.src = defaultImage;
    },
    oninput(val) {
      let temp = val.toString();
      temp = temp.replace(/。/g, ".");
      temp = temp.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
      temp = temp.replace(/^\./g, ""); //验证第一个字符是数字
      temp = temp.replace(/^0+(\d)/, "$1"); //第一位0开头，0后面为数字，则过滤掉，取后面的数字
      temp = temp.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
      temp = temp.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      return temp;
    },
    //如果失去焦点小数点后面没有数字则去掉小数点
    inBlur(value) {
      if (!Number(value)) return; //没有值不处理
      return Number(value).toFixed(2); //除了0其他自动补全0
    },
    isNewType() {
      if (this.oldType.indexOf(this.$route.query.taction) != -1) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * @author 伟健 / 张
     * @name 修改分页
     */
    handlePageNoChange(index) {
      this.formData.pageNo = index;
      this.getList();
    },
    // 路由跳转
    push(param, type) {
      if (param && !type) {
        this.$router.push(param);
      }
      if (type == "open") {
        console.log(param.path);

        window.fixOpen(
          `${window.location.origin}${window.location.pathname}` +
          "#" +
          param.path +
          "?" +
          qs.stringify(param.query)
        );
      }
    },
    wopen(path, _self) {
      if (!path) return;
      if (_self) {
        window.location.href = path;
      } else {
        window.fixOpen(path);
      }
    },
    getSignTaction() {
      if (!this.$route.query.taction) return "";
      let keys = Object.keys(this.signApis);

      let taction = "";
      keys.forEach((key) => {
        if (this.$route.query.taction.indexOf(key) > -1) {
          taction = key;
        }
      });
      return this.signApis[taction];
    },
    getTaction() {
      if (!this.$route.query.taction) return "";
      let keys = Object.keys(this.pageApis);

      let taction = "";
      keys.forEach((key) => {
        if (this.$route.query.taction.indexOf(key) > -1) {
          taction = key;
        }
      });
      return this.pageApis[taction];
    },
    // 返回
    back(param) {
      if (param && !param.target) {
        this.$router.replace(param);
      } else {
        this.$router.back(); //返回上一层
      }
    },
    copyItem(content) {
      let txt = content;
      console.log("复制1");
      if (!isIE()) {
        console.log("复制2");
        copyText(txt, () => {
          Mirror.emit("tips_bus", {
            msg: "复制成功",
            type: "success",
          });
        });

        // let   type = "text/plain";
        // let   blob = new Blob([txt], { type });
        // let   data = [new ClipboardItem({ [type]: blob })];

        // navigator.clipboard.write(data).then(
        //   () => {
        //     // 成功
        //     Mirror.emit('tips_bus', {
        //       type: "success",
        //       msg: "复制成功",
        //     });
        //   },
        //   () => {
        //     // 失败
        //     Mirror.emit('tips_bus', {
        //       type: "error",
        //       msg: "复制失败",
        //     });
        //   }
        // );
        // Mirror.emit('tips_bus', {
        //   type: "success",
        //   msg: "复制成功",
        // });
        // return navigator.clipboard.writeText(txt);
      } else {
        console.log("复制3");
        let textArea = document.createElement("textarea");
        textArea.value = txt;
        document.body.appendChild(textArea);
        // textArea.focus();
        textArea.select();
        Mirror.emit("tips_bus", {
          type: "success",
          msg: "复制成功",
        });
        return new Promise((res, rej) => {
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        });
      }
    },
    downloadFile(url, show) {
      if (show) {
        window.fixOpen(`${url}?attname=${url.substring(url.lastIndexOf("/"))}`);
      } else {
        window.fixOpen(url);
        // console.log(`${url}?attname=${url.substring(url.lastIndexOf('/'))}`)
      }
    },
    getRouter(url) {
      // url = 'https://jinandev.tb.daily.baohantong.net/#/external/customs/confirm?tradeNo=CD20250123152903YI1GXEHRY9UN&tv=v1&taction=CustomsInsure&token=40eaf7b0c66e843479f966c865f64218829d7731cc0779e168f3866eff27bf06'
      let path = "";
      let query = {};
      let str = url.split("#")[1];
      path = str.split("?")[0];
      let json = str.split("?")[1];
      let arr = json.split("&");
      arr.forEach((item) => {
        let arr = item.split("=");
        query[arr[0]] = arr[1];
      });
      return { path, query };
    },
    showIframe() {
      if (window !== window.parent) {
        return true;
      } else {
        return false;
      }
    },
 
    /**
     * 将百分比折扣转换为指定的折扣显示格式
     * @param {string|number} percentage - 百分比字符串(如"95%")或数字(如95)
     * @returns {string} 格式化后的折扣字符串(如"9.5折")
     */
    formatDiscount(percentage) {
      if (!percentage) return '0';
      // 处理输入参数
      let percentValue;

      if (typeof percentage === 'string') {
        // 去掉空格，去掉百分号
        const cleanStr = percentage.trim().replace('%', '');
        percentValue = parseFloat(cleanStr);
      } else if (typeof percentage === 'number') {
        percentValue = percentage;
      } else {
        throw new Error('请输入有效的百分比值（字符串或数字）');
      }

      // 验证输入是否有效
      if (isNaN(percentValue) || percentValue < 0) {
        throw new Error('请输入有效的百分比值（0-100之间的数字）');
      }

      // 计算折数（百分比除以10）
      const discount = percentValue / 10;

      // 将折数转换为指定格式
      const discountStr = discount.toFixed(1); // 保留一位小数

      // 分割整数部分和小数部分
      const [integerPart, decimalPart] = discountStr.split('.');

      // 构建结果字符串
      if (decimalPart === '0') {
        // 如果小数部分为0，只显示整数部分
        return `${integerPart}`;
      } else {
        // 显示完整的小数形式
        return `${discountStr}`;
      }
    }
  },
};
